import type { Origin } from 'api/resources/apiConfig/types';

export const buildCompositeMetricOptions = (
  metricNames: string[],
  origin: Origin,
): Array<{ value: string; label: string; isCustom?: boolean }> => {
  return metricNames.map(name => ({
    value: `${name}__${origin}`,
    label: name,
    isCustom: origin === 'custom',
  }));
};

export const areAllMetricsSelected = (
  selectedNames: Set<string>,
  customMetrics: string[],
  standardMetrics: string[],
): boolean => {
  const allUnique = Array.from(new Set([...customMetrics, ...standardMetrics]));
  return (
    allUnique.length > 0 && allUnique.every(name => selectedNames.has(name))
  );
};

export const parseCompositeValues = (
  formMetrics: Array<{ value: string }> | undefined,
): Set<string> => {
  return new Set(formMetrics?.map(m => m.value).filter(v => v !== '*') ?? []);
};

export const filterDuplicateCustomMetrics = (
  customMetrics: string[],
  standardMetrics: string[],
): string[] => {
  const standardMetricNames = new Set(standardMetrics);
  return customMetrics.filter(name => !standardMetricNames.has(name));
};
